import React, { Fragment, useState, useEffect, useMemo } from "react";
// import Breadcrumb from "../../../layout/breadcrumb";
import Breadcrumbs from "../../../../layout/breadcrumb";
import { Badge, Button } from "reactstrap";

// import SearchStaticCommissions from "./search-static-commissions";
import { MaterialReactTable } from 'material-react-table';
import { Box } from "@mui/material";
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { deleteProductClientByDealershipId, getCompanyById, getDealerById, getProductById } from "../../../../api";
import { getAllProductClientByDealershipId } from "../../../../api";
import { toast } from "react-toastify";
import { useParams } from 'react-router-dom';
import formatedDate from "../../../../utilities/formatedDate";
import { faTrash, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import SweetAlert from 'sweetalert2';
import GetButtons from "../../../common/getButtons";
import GetExport from "../../../common/getExport";
import { getFromLocalStorage } from "../../../../hooks/useLocalStorage";
import ViewProductModal from "../../../sales/products/view-product-modal";



const AssignedDealershipsToClient = () => {

  const [dealerData, setDealerData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [productData, setProductData] = useState({});
  const [viewProductModal, setViewProductModal] = useState(false);
  const toggleViewProductModal = () => setViewProductModal(!viewProductModal);
  const { company_id } = useParams();
  // const [dealerName, setDealerName] = useState({});
  const [companyData, setCompanyData] = useState({});

  const [adminColumn] = useState(getFromLocalStorage('ROLE')?.key == "ADMIN" || getFromLocalStorage('ROLE')?.key == "TEAM_MEMBER" ? true : false);

  const [dealership_id] = useState(getFromLocalStorage("user")?.dealerInfo?.dealership_id);

  // useEffect(() => {
  //   fetchAllProductClientByDealershipId();
  //   fetchDealerById(dealership_id);
  // }, [dealership_id]);

  // const fetchDealerById = async () => {
  //   try {
  //     const response = await getDealerById(dealership_id);
  //     setDealerName(response.data.result); // Set dealer data in state
  //   } catch (error) {
  //     console.error("Error fetching dealer data:", error);
  //     toast.error(error.response.data.error);
  //   }
  // };

  useEffect(() => {
    fetchAllProductClientByDealershipId();
    fetchDealerById(company_id);
  }, [company_id]);

  const fetchDealerById = async (companyId) => {
    try {
      const response = await getDealerById(companyId);
      setCompanyData(response.data.result); // Set company data in state
    } catch (error) {
      console.error("Error fetching company data:", error);
      toast.error(error.response.data.error);
    }
  };


  const fetchAllProductClientByDealershipId = async () => {
    setIsLoading(true);
    // await getAllProductClientByDealershipId(dealership_id).then((res) => {      
      await getAllProductClientByDealershipId(company_id).then((res) => {
      setIsLoading(false);
      setDealerData(res.data.result);
    }).catch((err) => {
      toast.error(err.response.data.error);
    })
  }


  const refresh = () => {
    fetchAllProductClientByDealershipId()
  }


  const handleDelete = (row) => {
    try {
      let confirmationText = 'Delete';

      SweetAlert.fire({
        title: `Are you sure you want to "${confirmationText}" Product?`,
        text: "",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'YES',
        cancelButtonText: 'NO',
        reverseButtons: true
      }).then(async (result) => {
        if (result.value) {
          await deleteProductClientByDealershipId({product_dealership_id: row.original.product_dealership_id });
          toast.success('Product deleted successfully.');    
          refresh();    
        } else {
          toast.info('Product not deleted');
        }
      });
    } catch (error) {
      console.log(error, 'error');
      toast.error(error.response.data.error);
    }
  };

  const viewProduct = (e, data) => {
    console.log(data, "viewproduct data");
    // getProductById(data.product_id).then((res) => {
    //   const data = res.data.result;
    //   console.log(data, "product data");
    // })
    setProductData(data);
    setViewProductModal(!viewProductModal);

   
  };
  const columns = useMemo(
    () => [
      {
        accessorKey: 'product_client.product.product_name',
        header: 'Product Name',
        filter:false,
        enableClickToCopy: false,
        size: 80,
        Cell: ({ row }) => (
          <>
          <span
            style={{ color: "black", cursor: "pointer" }}
            onClick={(e) => viewProduct(e, row.original?.product_client.product)}
            className="font-primary"
          >
            {row?.original?.product_client.product.product_name}
     
          </span>
        </>
        ),
      },
      {
        accessorKey: 'product_client.product.Company.companyConfig',
        header: 'Client Age Limit',
        filter:false,
        enableClickToCopy: false,
        size: 80,
        Cell: ({ row }) => (
          <>
          <span className="font-primary">
            {row?.original?.product_client?.product?.Company?.companyConfig[0]?.value ? row?.original?.product_client?.product?.Company?.companyConfig[0]?.value : '5'}  
          </span>
        </>
        ),
      },
      {
        accessorKey: "status",
        header: "Status",
        // filter: false,
        enableSorting: false,
        enableColumnFilter: false,
        enableColumnActions: false,
        size: 10,
        // filterSelectOptions: [
        //   { text: 'Active', value: "Active" },
        //   { text: 'Deactivate', value: "Deactivate" },
        // ],
        filterVariant: "select",
        Cell: ({ row }) => (
          <div>
            <Badge
              color={
                row?.original?.product_client?.product?.status.toUpperCase() === "ACTIVE"
                  ? "success"
                  : row?.original?.product_client?.product?.status.toUpperCase() === "DEACTIVATE"
                  ? "danger"
                  : "default"
              }
            >
              {row?.original?.product_client?.product?.status.toUpperCase()}
            </Badge>
          </div>
        ),
      },
      {
        accessorKey: 'created_at',
        // header: 'Created Date',
        header: 'Assigned Date',
        filter:false,
        enableClickToCopy: false,
        enableColumnFilter: false,
        enableColumnActions: false,
        size: 80,
        Cell: ({ row }) => (
          <div>
            {formatedDate(row.original.created_at)}
          </div>
        ),
      },
      adminColumn && {
        accessorKey: 'action',
        header: 'Action',
        filter: false,
        enableClickToCopy: false,
        Cell: ({ row }) => {
          return (
            <div>
              {/* <FontAwesomeIcon
                // icon={faTrash}
                icon={faTimes}
                onClick={() => handleDelete(row)}
                style={{ color: "red", cursor: "pointer", fontSize: "20px" }}
              /> */}
              <span className="badge badge-danger" onClick={() => handleDelete(row)} style={{ cursor: "pointer" }}>Remove</span>
            </div>
          );
        },
      },
    ].filter(Boolean),
    [adminColumn],
 
  );

 

  const exportedData = dealerData?.map((item) => ({
    Product_Name: item.product_client?.product?.product_name,
    Assigned_on: formatedDate(item.created_at),
  }));




  return (
    <Fragment>
      {/* <Breadcrumbs parent="Affiliations"  title={
          dealerName?.dealer_name
            ? `Assigned Products for ${dealerName.dealer_name}`
            : "Client not found !"
        } /> */}
        <Breadcrumbs parent="Affiliations"  title={
          companyData?.dealer_name
            ? `Assigned Products for ${companyData.dealer_name}`
            : "Client not found !"
        } />
      
       <div>
        <MaterialReactTable
          columns={columns}
          data={dealerData ? dealerData : []}
          initialState={{ density: 'compact' }}
          renderTopToolbarCustomActions={({ table }) => (
            <Box sx={{ display: 'flex', gap: '0.3rem', p: '0.5rem', flexWrap: 'wrap' }} >
              <GetButtons onClick={refresh} type="refresh" />
              <GetExport columns={columns} exportedData={exportedData} name="Assigned_Dealership" />
            </Box>
            
          )}
          state={{
            isLoading,
          }}









              
          
        />
      </div>
      {viewProductModal && (
        <ViewProductModal
          isOpen={viewProductModal}
          toggle={toggleViewProductModal}
          selectedProductData={productData}
          // model={mappingModel}
          // variant={mappingVariant}
          // changeNewHistory={changeNewHistory}
          // changeExistingHistory={changeExistingHistory}
          // mappingFuel={mappingFuel}
          // mappingTransmission={mappingTransmission}
        />
      )}

    </Fragment>
  );
};

export default AssignedDealershipsToClient;
